import { alpha, Box, Button, Stack, styled } from '@mui/material';
import { getNavFloatShadow } from 'src/components/Navbar/DesktopDrawer/desktop-drawer.styles';
import { GLASS_BLUR, SUPPORTS_BACKDROP_FILTER } from 'src/constants/glass';

export const StripGroup = styled(Stack, { name: 'ComposerStripGroup' })(({ theme }) => ({
  position: 'relative',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '0.125rem',
  padding: '0.25rem',
  borderRadius: '0.75rem',
  border: `1px solid ${alpha(theme.palette.custom.OV.sys.outlineVariant, 0.75)}`,
  backgroundColor: alpha(theme.palette.custom.OV.sys.surfaceContainerLowest, 0.78),
  backdropFilter: GLASS_BLUR,
  WebkitBackdropFilter: GLASS_BLUR,
  boxShadow: getNavFloatShadow(theme),
  [SUPPORTS_BACKDROP_FILTER]: {
    backgroundColor: theme.palette.custom.OV.sys.surfaceBright,
  },
}));

export const StripButton = styled(Button, {
  name: 'ComposerStripButton',
  shouldForwardProp: (prop) => prop !== 'iconTone' && prop !== 'iconOnly',
})<{ iconTone?: 'note'; iconOnly?: boolean }>(({ theme, iconTone, iconOnly }) => ({
  gap: '0.4375rem',
  padding: '0.5rem 0.75rem',
  borderRadius: '0.5625rem',
  fontSize: '0.78125rem',
  fontWeight: 600,
  lineHeight: 1.2,
  textTransform: 'none',
  whiteSpace: 'nowrap',
  minWidth: 0,
  color: theme.palette.custom.OV.sys.onBackground,
  '& .MuiButton-startIcon': {
    margin: 0,
    color:
      iconTone === 'note'
        ? theme.palette.custom.OV.extended.Signature.color
        : theme.palette.custom.OV.sys.onSurfaceVariant,
  },
  '&:hover': { backgroundColor: theme.palette.custom.OV.sys.surfaceContainerHigh },
  ...(iconOnly && {
    padding: '0.5rem',
    '& > :not(.MuiButton-startIcon)': { display: 'none' },
  }),
}));

export const StripRecipient = styled('span', { name: 'ComposerStripRecipient' })(
  ({ theme }) => ({
    color: theme.palette.custom.OV.sys.onSurfaceVariant,
    fontWeight: 500,
  }),
);

export const OfferQuestion = styled(Box, { name: 'ComposerStripOfferQuestion' })(
  ({ theme }) => ({
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.5rem',
    fontSize: '0.75rem',
    // font-native line box, so the question and the 11.5px buttons centre on the same line
    lineHeight: 'normal',
    color: theme.palette.custom.OV.sys.onSurfaceVariant,
    whiteSpace: 'nowrap',
  }),
);

export const OfferButton = styled(Button, {
  name: 'ComposerStripOfferButton',
  shouldForwardProp: (prop) => prop !== 'tone',
})<{ tone?: 'accept' }>(({ theme, tone }) => ({
  minWidth: 0,
  padding: '0.375rem 0.5625rem',
  borderRadius: '0.4375rem',
  fontSize: '0.71875rem',
  fontWeight: 700,
  letterSpacing: '0.02em',
  lineHeight: 'normal',
  textTransform: 'none',
  color: theme.palette.custom.OV.sys.onSurfaceVariant,
  '&:hover': {
    backgroundColor: theme.palette.custom.OV.sys.surfaceContainerHigh,
    color: theme.palette.custom.OV.sys.onBackground,
  },
  ...(tone === 'accept' && {
    color: theme.palette.custom.OV.sys.surfaceContainerLowest,
    backgroundColor: theme.palette.custom.OV.sys.tertiary,
    '&:hover': {
      backgroundColor: theme.palette.custom.OV.sys.tertiary,
      color: theme.palette.custom.OV.sys.surfaceContainerLowest,
      filter: 'brightness(1.07)',
    },
  }),
}));
